export type ColorScheme =
  | 'default'
  | 'dark'
  | 'light'
  | 'dracula'
  | 'nord'
  | 'one-dark'
  | 'neon'
  | 'github-dark';

export const DEFAULT_SCHEME: ColorScheme = 'default';

export const AVAILABLE_SCHEMES: { value: ColorScheme; label: string }[] = [
  { value: 'default', label: 'Default' },
  { value: 'dark', label: 'Dark Mode' },
  { value: 'light', label: 'Light Mode' },
  // { value: 'dracula', label: 'Dracula' },
  // { value: 'nord', label: 'Nord' },
  // { value: 'one-dark', label: 'One Dark' },
  // { value: 'neon', label: 'Neon' },
  // { value: 'github-dark', label: 'GitHub Dark' },
];
